import { render, staticRenderFns } from "./volunteerHome.vue?vue&type=template&id=fbd2f07c&scoped=true"
import script from "./volunteerHome.vue?vue&type=script&lang=js"
export * from "./volunteerHome.vue?vue&type=script&lang=js"
import style0 from "./volunteerHome.vue?vue&type=style&index=0&id=fbd2f07c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2f07c",
  null
  
)

export default component.exports